import useLocalization from '../../../Localization';
import EditableCell from '../../CommonComponents/EditableCell';
import {Form, Table, Tag} from 'antd';
import moment from 'moment';

const WaitingList = ({data, showSponsorshipType = false}) => {
  const {ApplicationString} = useLocalization();
  const getAttendanceTypeLabel = (record) => {
    const raw = (record?.attendance_type ?? '').toString().trim().toLowerCase();
    const isWebcast = raw.includes('web');
    if (isWebcast)
      return (
        ApplicationString['waitingList.attendanceType.webcast'] || 'Webcast'
      );
    return (
      ApplicationString['waitingList.attendanceType.inPerson'] || 'In person'
    );
  };
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return (
          <Tag prefixCls='regularAttendeesTag'>
            {record.first_name} {record.last_name}
          </Tag>
        );
      },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (text) => {
        return <Tag prefixCls='regularAttendeesTag'>{text}</Tag>;
      },
    },
        {
      title:
        ApplicationString['waitingList.attendanceType'] || 'Attendance Type',
      dataIndex: 'attendance_type',
      key: 'attendance_type',
      render: (_, record) => {
        return (
          <Tag prefixCls='regularAttendeesTag'>
            {getAttendanceTypeLabel(record)}
          </Tag>
        );
      },
    },
    ...(showSponsorshipType
      ? [
          {
            title: 'Sponsorship Type',
            dataIndex: 'sponsorship_type',
            key: 'sponsorship_type',
            render: (_, record) => {
              const optionName = record?.event_option_name;
              if (!optionName) {
                return <Tag prefixCls='regularAttendeesTag'>-</Tag>;
              }
              return <Tag prefixCls='regularAttendeesTag'>{optionName}</Tag>;
            },
          },
        ]
      : []),
    {
      title: 'Date',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => {
        if (!text) return <Tag prefixCls='regularAttendeesTag'>-</Tag>;
        return (
          <Tag prefixCls='regularAttendeesTag'>
            {moment(text).format('MM/DD/YYYY')}
          </Tag>
        );
      },
    },
  ];
  return (
    <Form>
      <div className='attendees-content-container'>
        <div className='attendees-label'>
          {ApplicationString['waitingListAttendees']}
        </div>
      </div>

      <Table
        prefixCls='attendees-table-container'
        components={{
          body: {
            cell: (props) => <EditableCell {...props} usedForSponsorDetails />,
          },
        }}
        scroll={{x: columns?.length * 150}}
        rowClassName={() => 'editable-row'}
        dataSource={data}
        columns={columns}
        pagination={false}
      />
    </Form>
  );
};

export default WaitingList;
